import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Box, Flex, Text } from 'components/ui';
import { mediaQueries, space } from 'style/config';
import Empty from 'constants/empty';

const getListStyle = (columns, splitAt) => {
    if (splitAt) {
        return styles.splitList;
    }

    if (columns === 1) {
        return styles.oneColumnList;
    }

    if (columns === 3) {
        return styles.threeColumnList;
    }

    return styles.twoColumnList;
};

/**
 * Renders display-only Benefits rows with the configured icon and text.
 */
const BenefitIconList = ({ benefits = Empty.Array, columns = 2, splitAt = 0, splitFooter = null }) => {
    if (!benefits.length) {
        return null;
    }

    const splitIndex = columns === 2 && splitAt > 0 && splitAt < benefits.length ? splitAt : 0;
    const benefitGroups = splitIndex ? [benefits.slice(0, splitIndex), benefits.slice(splitIndex)] : [benefits];

    return (
        <Box css={getListStyle(columns, splitIndex)}>
            {benefitGroups.map((group, groupIndex) => (
                <Box
                    key={groupIndex}
                    css={styles.group}
                >
                    <>
                        {group.map((benefit, index) => (
                            <Flex
                                key={benefit.id || benefit.title || index}
                                alignItems='flex-start'
                                gap={2}
                                lineHeight='tight'
                            >
                                {benefit.icon && (
                                    <Text
                                        aria-hidden={true}
                                        flexShrink={0}
                                        fontSize='base'
                                        lineHeight='tight'
                                        children={benefit.icon}
                                    />
                                )}
                                <Text
                                    is='span'
                                    fontSize='base'
                                    lineHeight='tight'
                                    children={benefit.title}
                                />
                            </Flex>
                        ))}
                        {splitIndex > 0 && splitFooter && groupIndex === benefitGroups.length - 1 && splitFooter}
                    </>
                </Box>
            ))}
        </Box>
    );
};

const styles = {
    oneColumnList: {
        display: 'grid',
        gridTemplateColumns: '1fr',
        rowGap: space[4],
        [mediaQueries.smMax]: {
            rowGap: space[3]
        }
    },
    splitList: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        columnGap: space[6],
        [mediaQueries.smMax]: {
            gridTemplateColumns: '1fr',
            rowGap: space[3]
        }
    },
    group: {
        display: 'grid',
        gridTemplateColumns: '1fr',
        rowGap: space[3]
    },
    twoColumnList: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        columnGap: space[6],
        rowGap: space[4],
        [mediaQueries.smMax]: {
            gridTemplateColumns: '1fr',
            rowGap: space[3]
        }
    },
    threeColumnList: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
        columnGap: space[6],
        rowGap: space[4],
        [mediaQueries.smMax]: {
            gridTemplateColumns: '1fr',
            rowGap: space[3]
        }
    }
};

export default wrapFunctionalComponent(BenefitIconList, 'BenefitIconList');
